import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0;
`;

export const HyattTermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <h2 className="page-heading" style={{ color: '#041761' }}>
        {t('hyattTermsAndConditions')}
      </h2>
      <span>
        {t('hyattTermsAndConditionsAgreement')}{' '}
        <a
          href="https://world.hyatt.com/content/gp/en/privacy/guest-policy.html"
          target="_blank"
          rel="noreferrer"
        >
          {t('hyattTermsAndConditionsLink')}
        </a>
      </span>
    </Wrapper>
  );
};

export default HyattTermsAndConditions;
